export const primaryNavItemMixin = {
  data() {
    return {
      navItems: [
        {
          title: 'Calendar',
          langTitle: this.$t('lblCalender'),
          component: null,
          primary: true,
          isActive: false,
        },
        {
          title: 'Recipes',
          langTitle: this.$t('lblRecipes'),
          component: 'Recipes',
          primary: true,
          isActive: false,
        },
        {
          title: 'Plans',
          langTitle: this.$t('lblPlans'),
          component: 'Plans',
          primary: true,
          isActive: false,
        },
        {
          title: 'Favorites',
          langTitle: this.$t('lblFavorites'),
          component: 'Favorites',
          primary: true,
          isActive: false,
        },
      ],
    };
  },
  methods: {
    getPrimaryNavItems() {
      return this.navItems;
    },
  },
};
